import { render, staticRenderFns } from "./SubidTransform.vue?vue&type=template&id=0213f47b&scoped=true"
import script from "./SubidTransform.vue?vue&type=script&lang=js"
export * from "./SubidTransform.vue?vue&type=script&lang=js"
import style0 from "./SubidTransform.vue?vue&type=style&index=0&id=0213f47b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0213f47b",
  null
  
)

export default component.exports